import { render, staticRenderFns } from "./centerPanel.vue?vue&type=template&id=a27c55c2&scoped=true"
import script from "./centerPanel.vue?vue&type=script&lang=js"
export * from "./centerPanel.vue?vue&type=script&lang=js"
import style0 from "./centerPanel.vue?vue&type=style&index=0&id=a27c55c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27c55c2",
  null
  
)

export default component.exports